import { store } from './store';
import { useReState } from './useReState';
export function createReState(key, initialValue) {
  store.setWithoutNotify(key, initialValue);
  return function useCreatedUseReState() {
    return useReState(key);
  };
}